module.exports = __webpack_public_path__ + "img/zz.1c7b7e32.png";